angular.module('unica_event.event_controllers')

.controller('EventSendController',
	function(
		$rootScope, $scope, $state, $stateParams,
		$confirm, $uibModal,
		EventSendService, InvitationListListService
	) {

	$scope.event_id = $stateParams.event_id;

	$scope.invitationsLists = [];

	$rootScope.getEvent( $stateParams.event_id );

	function parseSentDate(data) {
		angular.forEach(data, function(st, key) {
			if ( st.sent_date ) {
				data[key].sent_date = moment.unix( st.sent_date ).toDate();
			}
		});
		return data;
	}

	$scope.loadInvitationsLists = function() {
		$scope.showLoader();

		InvitationListListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					data = parseSentDate(data);
					$scope.invitationsLists = $scope.invitationsLists.concat( data );
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadInvitationsLists();


	$scope.confirmSend = function() {
		$confirm({
			title: 'Conferma Invio Inviti',
			text: 'Confermi l\'invio degli inviti?'
		}).then(function() {

			$scope.showLoader();
			EventSendService
				.send( $stateParams.event_id  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						$scope.invitationsLists = parseSentDate(data.invitation_lists);
						$scope.showSuccessMsg( data.sent + ' inviti inviati con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});

		}, function() {
			// Cancel
		});
	};

		$scope.sendSingleInvitationList = function( invitationListId )
		{
			$confirm({
				title: 'Conferma Invio Inviti',
				text: 'Confermi l\'invio degli inviti?'
			}).then(function() {

				$scope.showLoader();
				EventSendService
					.send( $stateParams.event_id, invitationListId )
					.then(function(data) {
						$scope.hideLoader();

						if ( data ) {
							$scope.invitationsLists = parseSentDate(data.invitation_lists);
							$scope.showSuccessMsg( data.sent + ' inviti inviati con successo!', '');
						}
					});

			}, function() {
				// Cancel
			});
		};

		$scope.sendReminderSingleInvitationList = function( invitationListId )
		{
			$confirm({
				title: 'Conferma Invio Reminder Inviti',
				text: 'Confermi l\'invio degli inviti a quelli in attesa?'
			}).then(function() {

				$scope.showLoader();
				EventSendService
					.sendReminder( $stateParams.event_id, invitationListId )
					.then(function(data) {
						$scope.hideLoader();

						if ( data ) {
							$scope.invitationsLists = parseSentDate(data.invitation_lists);
							$scope.showSuccessMsg( data.sent + ' inviti inviati con successo!', '');
						}
					});

			}, function() {
				// Cancel
			});
		};


	$scope.openInvitationListModal = function (invitationListId)
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalInvitationListInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/invitation-list.html',
			size: 'lg',
			windowClass: 'modal-invitation-list',
			resolve: {
				invitationListId: function () {
					return invitationListId;
				}
			}
		});
	};

})


.controller('ModalInvitationListInstanceController',
	function ($scope, $uibModalInstance, invitationListId, InvitationListService) {


	$scope.invitations = [];


	$scope.loadInvitations = function() {
		$scope.showLoader();

		InvitationListService
			.fullList( invitationListId  )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.invitations = $scope.invitations.concat( data );
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$scope.loadInvitations();


	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

});
